import { computed, getCurrentInstance } from 'vue';

export type DatetimeType =
  | 'date'
  | 'datetime'
  | 'year'
  | 'month'
  | 'time'
  | 'week';

type Params = {
  type: DatetimeType;
  format?: string;
  valueType?: string;
  locale?: 'en' | 'hu' | string | null | undefined;
};

const VALUE_TYPE_MAP: Record<DatetimeType, string> = {
  date: 'YYYY-MM-DD',
  datetime: 'YYYY-MM-DD HH:mm',
  year: 'YYYY',
  month: 'YYYY-MM',
  time: 'HH:mm',
  week: 'gggg-[W]ww',
};

export function useItpDatetime({ type, format, valueType, locale }: Params) {
  const instance = getCurrentInstance();
  const $app = (instance?.proxy as any)?.$app ?? null;

  const effectiveType = type || 'date';

  const currentLocale = computed(() => locale || $app?.i18n?.locale || 'en');

  const displayFormat = computed(() => {
    if (format) {
      return format;
    }

    if (effectiveType === 'date') {
      if ($app?.i18n?.dateFormat) {
        return $app.i18n.dateFormat as string;
      }
      if (currentLocale.value === 'hu') {
        return 'YYYY.MM.DD';
      }
    }

    if (effectiveType === 'month') {
      return 'YYYY-MM';
    }
    if (effectiveType === 'datetime') {
      return 'YYYY-MM-DD HH:mm';
    }

    return VALUE_TYPE_MAP[effectiveType] || 'YYYY-MM-DD';
  });

  const modelValueType = computed(() => {
    if (valueType) {
      return valueType;
    }
    return VALUE_TYPE_MAP[effectiveType];
  });

  return {
    langObj: currentLocale,
    displayFormat,
    modelValueType,
  };
}
